import { useState } from "react";
import { Table, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/styles/customTable.scss";
import useColumnResize from "../../hooks/useColumnResize";
import api from "../../services/httpClient";

const DhlBranchTable = ({ data, onSortChange, onRefresh }) => {
  const [sortConfig, setSortConfig] = useState({ key: "Ex", direction: "asc" });
  const navigate = useNavigate();
  const { getResizeProps } = useColumnResize();

  const items = Array.isArray(data) ? data : [];

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    const newSortConfig = { key, direction };
    setSortConfig(newSortConfig);
    onSortChange(newSortConfig);
  };

  const getSortArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === "asc" ? "↑" : "↓";
    }
    return "";
  };

  const handleEdit = (id) => {
    navigate(`/administration/dhl-branches/edit/${id}`);
  };

  const handleDelete = async (id, ex, dr) => {
    if (!window.confirm(`Czy na pewno chcesz usunąć oddział ${ex}/${dr}?`)) return;
    try {
      await api.delete(`/Branch/${id}`);
      if (onRefresh) onRefresh();
    } catch (error) {
      console.error("Error deleting branch:", error);
      alert("Błąd podczas usuwania oddziału.");
    }
  };

  // Skrócony widok kodów pocztowych
  const renderPostcodes = (postcodesJson) => {
    if (!postcodesJson) return "—";
    try {
      const arr = JSON.parse(postcodesJson);
      if (!Array.isArray(arr) || arr.length === 0) return "—";
      const display = arr.slice(0, 5).join(", ");
      if (arr.length > 5) {
        return `${display} ... i ${arr.length - 5} więcej`;
      }
      return display;
    } catch {
      return "—";
    }
  };

  return (
    <div>
      <Table responsive striped bordered hover size="sm" className="custom-table">
        <thead>
          <tr>
            <th style={{ width: "120px" }} {...getResizeProps()}>Akcje</th>
            <th onClick={() => requestSort("Ex")} {...getResizeProps()}>
              EX {getSortArrow("Ex")}
            </th>
            <th onClick={() => requestSort("Dr")} {...getResizeProps()}>
              DR {getSortArrow("Dr")}
            </th>
            <th onClick={() => requestSort("OpenTimeFrom")} {...getResizeProps()}>
              Otwarty od {getSortArrow("OpenTimeFrom")}
            </th>
            <th onClick={() => requestSort("OpenTimeTo")} {...getResizeProps()}>
              Otwarty do {getSortArrow("OpenTimeTo")}
            </th>
            <th {...getResizeProps()}>Kody pocztowe</th>
          </tr>
        </thead>
        <tbody>
          {items.length > 0 ? (
            items.map((item, index) => (
              <tr key={`${item.id}-${index}`}>
                <td>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    className="me-1"
                    onClick={() => handleEdit(item.id)}
                    title="Edytuj"
                  >
                    ✏️
                  </Button>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => handleDelete(item.id, item.ex, item.dr)}
                    title="Usuń"
                  >
                    🗑️
                  </Button>
                </td>
                <td>{item.ex}</td>
                <td>{item.dr}</td>
                <td>{item.openTimeFrom}</td>
                <td>{item.openTimeTo}</td>
                <td style={{ fontSize: "11px" }}>{renderPostcodes(item.postcodes)}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center">
                Brak danych
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default DhlBranchTable;
